const Index = () => {
  return <div>Could not find the site.</div>;
};

export default Index;
